import warningTypes from './types/warningcenter'
import warningService from '@/api/warningcenter'

const state = {}

const actions = {
  /**
   * 获取短信发送地区列表
   */
  [warningTypes.GET_ADCDLIST] ({ commit }, { isneedjcfx, isgroup }) {
    return new Promise((resolve, reject) => {
      warningService.getAdcdlist({ isneedjcfx, isgroup }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取责任人列表
   */
  // [warningTypes.GET_PERSONLIST] ({ commit }, { personName, adcdList, position, remark, pageIndex, pageSize }) {
  //   return new Promise((resolve, reject) => {
  //     warningService.getPersonlist({ personName, adcdList, position, pageIndex, remark, pageSize }).then(res => {
  //       resolve(res.data)
  //     }).catch(err => reject(err))
  //   })
  // },
  [warningTypes.GET_PERSONLIST] ({ commit }, { personName, adcdList, deptId, adcdCode, position, remark, pageIndex, pageSize }) {
    return new Promise((resolve, reject) => {
      warningService.getPersonlist({ personName, adcdList, deptId, adcdCode, position, pageIndex, remark, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 短信发送
   */
  [warningTypes.SENG_MESSAGE] ({ commit }, { sendPersonList, sendTxt }) {
    return new Promise((resolve, reject) => {
      warningService.sendMsg({ sendPersonList, sendTxt }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取短信模板
   */
  [warningTypes.GET_MSGTEMP_LIST] ({ commit }, { pageIndex, pageSize }) {
    return new Promise((resolve, reject) => {
      warningService.getMsgTempList({ pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取部门及行政区划列表
  [warningTypes.GET_DEPT_ADCDLIST] ({ commit }) {
    return new Promise((resolve, reject) => {
      warningService.getDepAdcdList().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取下级行政区划列表
  [warningTypes.GET_NEXTADCDLIST] ({ commit }, { adcdLevel, adcdCode }) {
    return new Promise((resolve, reject) => {
      warningService.getNextadcdlist({
        adcdLevel, adcdCode
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取部门列表
  [warningTypes.GET_DEPTLIST] ({ commit }) {
    return new Promise((resolve, reject) => {
      warningService.getDeptlist().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 已发短信查询--获取数据
  [warningTypes.GET_SEND_MESSAGE_QUERY] ({ commit }, { warnNM = '', msgType = '', messageSendETM = '', messageSendSTM = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      warningService.getSendMessageQuery({ warnNM, msgType, messageSendETM, messageSendSTM, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 预报预警接口--获取数据
  [warningTypes.GET_PROXY_LIST_FORECAST_MESSAGE_DETAIL] ({ commit }, { messageSendETM = '', messageSendSTM = '', pageNumber = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      warningService.getProxyListForecastMessageDetail({ messageSendETM, messageSendSTM, pageNumber, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },

  // 已发短信查询--获取数据
  [warningTypes.GET_SENDMESSAGE_QUERY_LIABLEPERSON] ({ commit }, { ID = '', deptName = '', personName = '', sPHONE = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      warningService.getSendMessageQueryLiablePerson({ ID, deptName, personName, sPHONE, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 预警信息查看--获取数据
  // eslint-disable-next-line
  [warningTypes.GET_WARNRECORD_LIST] ({ commit }, { IsExistence='', isVillage = '', warnNM = '', warnTM_Min = '', warnTM_Max = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      warningService.getWarnRecordList({ IsExistence, isVillage, warnNM, warnTM_Min, warnTM_Max, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 预警信息查看--新增/编辑
  [warningTypes.SAVE_MESSAGE_TEMPLATE] (_, stationGroup) {
    return new Promise((resolve, reject) => {
      warningService.saveMessageTemplate(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 预警信息查看--删除
  [warningTypes.DELEDE_MESSAGE_TEMPLATE] ({ commit }, { id = '' }) {
    return new Promise((resolve, reject) => {
      warningService.deleteMessageTemplate({ id }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 预警信息查看--导出
  // eslint-disable-next-line
  [warningTypes.WARN_INFOLIST_EXPORT] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      warningService.warnInfoListExport(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 短信模板管理
  [warningTypes.GET_MESSAGE_TEMPLATELIST] ({ commit }, { iD = '', message = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      warningService.getMessageTemplateList({ iD, message, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取群组列表
  [warningTypes.GET_GROUPLIST] ({ commit }) {
    return new Promise((resolve, reject) => {
      warningService.getGrouplist().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 保存责任人信息
  [warningTypes.SAVE_PERSONINFO] (_, personinfoGroup) {
    return new Promise((resolve, reject) => {
      warningService.savePersoninfo(personinfoGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 删除责任人数据
  [warningTypes.DELETE_PERSONINFOGROUP] ({ commit }, { ids = '' }) {
    return new Promise((resolve, reject) => {
      warningService.deletePersoninfo({ ids }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取群组信息
  [warningTypes.GET_PERSONGROUPRELATION] ({ commit }, { relationName }) {
    return new Promise((resolve, reject) => {
      warningService.getPersonGroupRelation({ relationName }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 保存责群组信息
  [warningTypes.SAVE_PERSONGROUPRELATION] (_, personGroupRelation) {
    return new Promise((resolve, reject) => {
      warningService.savePersonGroupRelation(personGroupRelation).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取自然村列表
  [warningTypes.GET_NATURAL_VILLAGE_LIST] ({ commit }) {
    return new Promise((resolve, reject) => {
      warningService.getnaturalvillagelist().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获取已配置群组信息
  [warningTypes.GET_CONFIGURED_LIST] ({ commit }, { adcdCode, yJLX }) {
    return new Promise((resolve, reject) => {
      warningService.getconfiguredlist({ adcdCode, yJLX }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 保存群组配置信息
  [warningTypes.SAVE_CONFIGURED_INFO] (_, configGroup) {
    return new Promise((resolve, reject) => {
      warningService.saveconfiguredinfo(configGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 一键配置预警人员
  [warningTypes.ONE_CLICK_CONFIGURATION] (_, configGroup) {
    return new Promise((resolve, reject) => {
      warningService.oneclickconfiguration(configGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取预警信息
   */
  [warningTypes.GET_STATION_MAP] ({ commit }, { adcdCode, adcdName, adcdCodes }) {
    return new Promise((resolve, reject) => {
      warningService.getStationmap({ adcdCode, adcdName, adcdCodes }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取预警信息--新产生预警信息
   */
  [warningTypes.GET_NEW_EARLY_WARNING] ({ commit }) {
    return new Promise((resolve, reject) => {
      warningService.getNewEarlyWarning().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取预警信息--预警信息列表
   */
  [warningTypes.GET_EARLY_WARNING_LIST] ({ commit }, { yjtype, isscreen, pageIndex, pageSize }) {
    return new Promise((resolve, reject) => {
      warningService.getEarlyWarningList({ yjtype, isscreen, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 预警信息--改变预警状态信息
   */
  [warningTypes.CHANGE_WARNING_STATUS] ({ commit }, { WarnIds, WarnStatus }) {
    return new Promise((resolve, reject) => {
      warningService.changeMutipleWarning({ WarnIds, WarnStatus }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 行政区划
  [warningTypes.GET_NEXT_ADCD_LIST] ({ commit }, { adcdLevel, adcdCode }) {
    return new Promise((resolve, reject) => {
      warningService.getNextAdcdList({ adcdLevel, adcdCode }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 预警设置搜索获取乡镇街道信息
  [warningTypes.GET_BASE_STREET_LIST] ({ commit }, { IsTown, pageIndex, pageSize }) {
    return new Promise((resolve, reject) => {
      warningService.getStreetAdcdList({ IsTown, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 责任人管理--导出
  // eslint-disable-next-line
  [warningTypes.EXPORT_PERSONLIST] ({ commit }, { personName, adcdList, deptId, adcdCode, position, remark, pageIndex, pageSize }) {
    return new Promise((resolve, reject) => {
      warningService.exportPersonlist({ personName, adcdList, deptId, adcdCode, position, pageIndex, remark, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 根据预警id获取人员
  [warningTypes.person_order_warnid] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      warningService.person_order_warnid(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 责任人管理模板--下载
  [warningTypes.EXPORT_TEMPLATE_PERSONLIST] ({ commit }, { personName, adcdList, deptId, adcdCode, position }) {
    return new Promise((resolve, reject) => {
      warningService.exportPersonTemplatelist({ personName, adcdList, deptId, adcdCode, position }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
